<script>
  import { onMount, getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import { SEARCH_SPONSORS } from '../../graphql/sponsors';

  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';

  export let label;
  export let value;

  let search = '';
  let query = client.watchQuery({ query: SEARCH_SPONSORS, variables: { search } });
  let results = { loading: true };

  function setResponse({ data, loading, error, networkStatus }) {
    results = {
      loading,
      page: data && data.sponsors ? data.sponsors.page : 1,
      total: data && data.sponsors ? data.sponsors.total : 0,
      sponsors: data && data.sponsors ? data.sponsors.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({ error, loading: false });
    }
  });

</script>

<div>
  {#if label}<label>{label}</label>{/if}

  {#if results.loading}
  <Loader />
  {/if}

  {#if !results.loading}
  <select bind:value>
    <option value={null}>Choose a Program Sponsor</option>
    {#each results.sponsors as sponsor, i}
    <option value={sponsor.id}>
      {sponsor.name}
    </option>
    {/each}
  </select>
  {/if}
</div>